import React, {Component} from 'react';
import { Link } from "react-router-dom";
import blue from '../../styles/img/blue.svg';
import pica from '../../styles/img/pica.jpg';
import videoImg from '../../styles/img/video.png';
import cert from '../../styles/img/cert.png';
import './css/reset.css';
import './css/styles.css';

class CreateCourse extends Component {
  render() {
    return (
      <div className="main-content">
        {localStorage.token ? null :
          <section className="title-wrapper">
            <img 
              className="title-logo"
              src={blue}
              alt="Therapy Academy"
            />
            <h1 className='title'>CREATE YOUR WORKSHOP ONLINE</h1>
          </section>
        }
          <section className="main-info">
            {/* <div className="info-wrapper"> */}
              <div className="info-item">
              <h4>Pricing:</h4>
              <div className="list-wrapper">
                <ul>
                  <li>You choose the workshop fee</li>
                  <li>Therapy Academy charges 25% of this fee, <span className="left-margin"> you keep 75%</span></li>
                  <li>No setup, hosting or any other charges</li>
                </ul>
              </div>
            {/* </div> */}
            {/* <div className="info-item">
              <h4>No Hidden Costs:</h4>
              <div className="list-wrapper">
                <ul>
                  <li>No setup, hosting or online payment <span className="left-margin">provider charges</span></li>
                  <li>No other charges</li>
                </ul>
              </div>
            </div> */}
            </div>

            {/* <div className="info-wrapper"> */}
              <div className="info-item">
              <h4>COURSE PROMOTION &amp; CPD</h4>
              <div className="list-wrapper list-wrapper-185">
                <ul>
                  <li>3,500 Therapy <span className="left-margin">Academy Members</span></li>
                  <li>CPD certs automatically created for you</li>
                  <li>Workshop participants download cert upon completion of a quiz</li>
                </ul>
              </div>
            </div>
            {/* <div className="info-item" style={{marginTop: '100px'}}>
              <h4>Hassle Free CPD:</h4>
              <div className="list-wrapper list-wrapper-245">
                <ul>
                  <li>Fully automated</li>
                  <li>CPD certs automatically <span className="left-margin">create</span></li>
                  <li>Trainees download certificate <span className="left-margin">upon</span> completion of a quiz</li>
                </ul>
              </div> */}
            {/* </div> */}
            {/* </div> */}
        
            
          </section>
          <div className="site-width">

            <section className="create-course" style={{maxWidth: '430px'}}>
              <Link to="/createwebinar" className="button">Create your workshop online – It’s Free</Link>
            </section>

            <section className="offer double-offer">
              <div className="offer-info next-steps" style={{margin: "0 auto", textAlign: 'center'}}>
                <h2 className='create-course-header' style={{textAlign: 'center'}}>TESTIMONIALS</h2>
                <p><br />Thanks so much Therapy Academy for marketing and managing all the bookings for my online training provision. Your professionalism, excellent course layout and clear communication to me and participants throughout really optimised the outcome.
                </p>
                <p style={{color: '#8e8e8e'}}><br />- Ann Bracken, Counselling Psychotherapist </p>
              </div>
            </section>

            <section className="offer">
              <figure className="offer-image" style={{display: 'flex'}}>
                <img
                  className="image"
                  style={{margin: 'auto 0'}}
                  src={pica}
                  srcset="pica@2x.jpg 2x, pica@3x.jpg 3x"
                  alt="Transition your course"
                />
              </figure>
              <div className="offer-info">
                <h2 className='create-course-header'>Transition Your Workshop Online</h2>
                <p>If you have been delivering face to face workshops, or have course content available, we can help you transition these workshops onto TherapyAcademy.ie so that they are accessible to our 3,500 counsellors and psychotherapists in an online format.</p>
              </div>
            </section>


            <section className="our_video">
              <h2 className='create-course-header'>Creating Your Workshop Online</h2>
              <p>We are here to help you each step of the way</p>
              <iframe src="https://player.vimeo.com/video/402727313" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen className="video-image"></iframe>
            </section>


            <section className="offer double-offer">
              <div className="offer-info course-types">
                <h2 className='create-course-header'>Workshop Types</h2>
                <ul>
                  <li>Live Webinars – enables you to present to a large audience with chat Q&A style interaction OR your participants can interact live through video and audio
                  </li>
                  <li>Online Workshops - These allow participants to learn at their own pace through a mixture of written content, video content, articles, research etc.
                  </li>
                  <li>Online Presentations - presentation style workshops delivered via video
                  </li>
                </ul>
              </div>
              <div className="offer-info">
                <h2 className='create-course-header'>Participant Engagement</h2>
                <p><br />We have two methods to measure workshop engagement of participants:
                </p>
                <ul>
                  <li>Automated quiz – true / false questions for each module OR
                  </li>
                  <li>Open ended questions – workshop provider poses questions, followed by participant answers & workshop provider responses
                  </li>
                </ul>
                <br />
                <p>In both cases, supporting documentation and further reading can also be added.
                </p>
              </div>
            </section>

            <section className="offer">
              <figure className="offer-image">
                <img className="image" src={cert} srcset="cert@2x.jpg 2x, cert@3x.jpg 3x" alt="Transition your course" />
              </figure>
              <div className="offer-info">
                <h2 className='create-course-header'>CPD Accreditation</h2>
                <p>Each workshop published on TherapyAcademy.ie can be accredited for CPD. Each participant who takes your workshop online will be required to complete a short MCQ quiz. Upon successful completion of the quiz, a CPD cert is automatically generated for them containing all the details that they can download.
                </p>
              </div>
            </section>


            <section className="offer double-offer">

              {/* <div className="offer-info">
                <h2 className='create-course-header'>Pricing</h2>
                <ul>
                  <li>You choose the course fee</li>
                  <li>75% of the course fee goes to you & 25% to Therapy Academy</li>
                  <li>No signup, hosting or any other fees</li>
                </ul>
              </div> */}
              <div className="offer-info next-steps" style={{margin: "0 auto"}}>
                <h2 className='create-course-header' style={{textAlign: 'center'}}>Next Steps</h2>

                <p><br />Contact us at <a href="maito: support@therapyacademy.ie">support@therapyacademy.ie</a> or on <a href="tel: 087 3356536">087 3356536</a> and we can work with you to get your workshop set up immediately.
                </p>

                {/* <h5>Alternatively, follow these steps:</h5>
                <ol>
                  <li>Create a free account on Therapy Academy</li>
                  <li>Submit proposed course details for approval here - 
                    <a href="https://therapyacademy.ie/createworkshop" target='_blank'>https://therapyacademy.ie/createworkshop</a>
                  </li>
                  <li>We will assess your course and after approval by us, you can start to add the content of your course online</li>
                  <li>Therapy Academy will tailor your course for an online audience</li>
                  <li>Once you are satisfied with course, we publish it on TherapyAcademy.ie where it can be accessed by our 2,500 members</li>
                </ol> */}
              </div>
            </section>
          </div>
        </div>
    );
  }
}

export default CreateCourse;


// WEBPACK FOOTER //
// ./src/components/create_course/index.jsx